'use strict';
var populationList = document.querySelectorAll('.population');
var averagePopulation = document.querySelector('.average-population');
var totalPopulation = document.querySelector('.total-population');
var populationArray = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = populationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var populationItem = _step.value;
        var populationValue = populationItem.textContent.split(',').join('');
        populationArray.push(populationValue);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var sumPopNum = populationArray.reduce(function(sum, population) {
    return sum + Number(population);
}, 0);
var averagePopNum = sumPopNum / populationArray.length;
totalPopulation.textContent = sumPopNum.toLocaleString('en-US');
averagePopulation.textContent = averagePopNum.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

//# sourceMappingURL=js_get_data_DOM.4faf253e.js.map
